import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ModalController } from '@ionic/angular';

export const CAUSES: string[] = [
  'THERAPY_ACHIEVED', 'PATIENT_DECEASED', 'MORE_MONITORING_IMPOSSIBLE',
  'FOR_PATIENT_REQUEST', 'HOSPITALIZATION', 'OTHER'
];

@Component({
  selector: 'inc-therapy-discontinuation',
  templateUrl: './therapy-discontinuation.component.html',
  styleUrls: ['./therapy-discontinuation.component.scss'],
})
export class TherapyDiscontinuationComponent implements OnInit {
  title = 'THERAPY_TERMINATION';
  therapyDiscontinuationForm: FormGroup;
  causes = CAUSES;

  constructor(private modalController: ModalController) { }

  ngOnInit() {
    this.reset();
  }

  close() {
    this.modalController.dismiss();
  }

  reset(): void {
    this.therapyDiscontinuationForm = this.resetForm();
  }

  resetForm(): FormGroup {
    return new FormGroup({
      causes: new FormControl(''),
      comments: new FormControl('')
    });
  }

  save() {
    this.modalController.dismiss({ value: { therapyTermination: this.therapyDiscontinuationForm.value } });
  }

  resetSelect(): void {
    this.therapyDiscontinuationForm.controls.causes.reset();
  }
}
